import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { List, Image, Space, ImageViewer, Button,Toast } from "antd-mobile";
import {
  MessageOutline,
  UserOutline,
} from "antd-mobile-icons";

import './index.less';
import request from "../../../utils/request";
/**
 * @name gameMode
 * 0 gameMode为0时展示的item结构
 * 1 gameMode为1时展示的item结构
 */
const ListItem = ({
  item,
  buttonInfo,
  gameMode,
  rootId,
  setImgShow,
  setImgTextShow,
  filterTabList,
}) => {
  const navigate = useNavigate();
  const [search, setSearchParams] = useSearchParams();
  const goGameList = (item) => {
    navigate(
      `/gamelist/${
        item?.goodsId || item?.id
      }?mode=${gameMode}&gameid=${search.get("id")}`
    );
  };

  /**
   * @name VIEW_ITEM
   * 0 默认样式
   * 1 整体样式为jieweilai时展示的item结构
   */
  const gameModeOneItem = () => {
    const VIEW_ITEM = 1;

    const defaultItem = () => (
      <List.Item
        arrow={false}
        key={item?.goodsId || item?.id}
        className="list-item"
      >
        <div className="list-item-title">
          <div className="p-game-list-img">
            <span className="img-num">{item?.images?.length}图</span>
            <Space wrap>
              <Image
                src={item?.images?.[0]?.auditImage}
                onClick={() => {
                  setImgShow(true);
                  ImageViewer.Multi.show({
                    images: item?.images?.map(
                      (value) => value?.originImage || value
                    ),
                    onClose: () => {
                      setImgShow(false);
                    },
                  });
                }}
              />
            </Space>
            <div className="tips" onClick={() => goGameList(item)}>
              <div className="tip blue">{item?.categoryName}</div>
              {item?.serverName && (
                <>
                  <i></i>
                  <div className="tip">{item?.serverName}</div>
                </>
              )}
              <i></i>
              <div className="tip">
                {filterTabList?.filter((v) => v?.id === rootId)?.[0]?.name}
              </div>
            </div>
          </div>
          <div className="game-detail-info">
            <div className="game-info" onClick={() => goGameList(item)}>
              <div className="title">{item?.title}</div>
              <div className="game-tag-list">
                {(item?.sellPoints || [])?.map((v) => (
                  <span>{v?.tagName}</span>
                ))}
              </div>
              <div className="tag-box">
                <div className="tag-list">
                  <div className="tag-item">找回包赔</div>
                  <div className="tag-item">官方验号</div>
                  <div className="tag-item">安全保障</div>
                </div>
              </div>
            </div>

            <div className="item-detail" onClick={() => goGameList(item)}>
              <div className="item-price">
                ￥{(item?.price * 1 || 0)?.toFixed(2)}
              </div>
              {buttonInfo?.name && (
                <Button
                  shape="default"
                  color="primary"
                  onClick={() => {
                    window.open(`${buttonInfo?.url}`);
                  }}
                >
                  {buttonInfo?.name}
                </Button>
              )}
            </div>
            <div className="game-customer">
              {buttonInfo?.data?.button_list?.button_list_server?.map((v) => (
                <Button onClick={() => goCustomer(v?.url)} color="primary">
                  {v?.ico && <img src={v?.ico} />}
                  <MessageOutline />
                  {v?.value}
                </Button>
              ))}
              {/* <div className='customer-item' onClick={goCustomer}>
                                            <div><UserOutline /></div>
                                            <span>客服</span>
                                          </div> */}
              {/* <div className='customer-item'>
                                            <div><StarFill /></div>
                                            <span>收藏</span>
                                          </div> */}
            </div>
          </div>
        </div>
      </List.Item>
    );
    const jieWeiLai = () => (
      <List.Item
        arrow={false}
        key={item?.goodsId || item?.id}
        className="list-item list-item-jieweilai"
      >
          <div className="title" onClick={() => goGameList(item)}>{item?.title}</div>
          <div className="content-main">
            <div className="p-game-list-img">
              <span className="img-num">{item?.images?.length}图</span>
              <Space wrap>
                <Image
                  src={item?.images?.[0]?.auditImage}
                  onClick={() => {
                    setImgShow(true);
                    ImageViewer.Multi.show({
                      images: item?.images?.map(
                        (value) => value?.originImage || value
                      ),
                      onClose: () => {
                        setImgShow(false);
                      },
                    });
                  }}
                />
              </Space>
              
            </div>
            <div className="game-detail-info">
              <div className="game-info" onClick={() => goGameList(item)}>
              <div className="tips" >
                  <div className="tip blue">{item?.categoryName}</div>
                  {item?.serverName && (
                    <>
                      <i></i>
                      <div className="tip">{item?.serverName}</div>
                    </>
                  )}
                  <i></i>
                  <div className="tip">
                    {filterTabList?.filter((v) => v?.id === rootId)?.[0]?.name}
                  </div>
                </div>
                <div className="game-tag-list">
                  {(item?.sellPoints || [])?.map((v) => (
                    <span>{v?.tagName}</span>
                  ))}
                </div>
                <div className="tag-box">
                  <div className="tag-list"
                    onClick={(event) => {
                      event.stopPropagation();
                      setImgTextShow(true);
                      ImageViewer.show({
                        image: [require("../../../config/img/code.png")],
                        onClose: () => {
                          setImgTextShow(false);
                        },
                      });
                    }}
                  >
                    <div className="tag-item">找回包赔</div>
                    <div className="tag-item">官方验号</div>
                    <div className="tag-item">安全保障</div>
                  </div>
                </div>
              </div>

              <div className="item-detail" onClick={() => goGameList(item)}>
                <div className="item-price">
                  ￥{(item?.price * 1 || 0)?.toFixed(2)}
                </div>
                {buttonInfo?.name && (
                  <Button
                  size='small'
                    shape="default"
                    color="primary"
                    onClick={() => {
                      window.open(`${buttonInfo?.url}`);
                    }}
                  >
                    {buttonInfo?.name}
                  </Button>
                )}
              </div>
              <div className="game-customer">
                  <CopyToClipboard
                      text={ `${item?.title};id：${item?.goodsId || item?.id};￥${item?.price}`}
                    >
                      <Button
                        size='small'
                        color='primary'
                        onClick={() => {
                          Toast.show({
                            content: '复制成功'
                          })
                        }}
                    >
                      一键复制
                    </Button>
                </CopyToClipboard>
                {buttonInfo?.data?.button_list?.button_list_server?.map((v) => (
                  <Button onClick={() => goCustomer(v?.url)} color="primary">
                    {v?.ico && <img src={v?.ico} />}
                    <MessageOutline />
                    {v?.value}
                  </Button>
                ))}
                {/* <div className='customer-item' onClick={goCustomer}>
                                            <div><UserOutline /></div>
                                            <span>客服</span>
                                          </div> */}
                {/* <div className='customer-item'>
                                            <div><StarFill /></div>
                                            <span>收藏</span>
                                          </div> */}
              </div>
            </div>
          </div>
      </List.Item>
    );
    return VIEW_ITEM == 1 ? jieWeiLai() : defaultItem();
  };

  const gameModeItem = () => {
    return (
      <List.Item
        arrow={false}
        key={item?.goodsId}
        className="list-item list-item-mode"
      >
        <div className="list-item-title">
          <div className="p-game-list-img">
            <span className="img-num">{item?.images?.length}图</span>
            <Space wrap>
              <Image
                src={item?.images?.[0]}
                onClick={() => {
                  setImgShow(true);
                  ImageViewer.Multi.show({
                    images: item?.images?.map(
                      (value) => value?.originImage || value
                    ),
                    onClose: () => {
                      setImgShow(false);
                    },
                  });
                }}
              />
            </Space>
            <div className="tips" onClick={() => goGameList(item)}>
              <div className="tip blue">{item?.categoryName}</div>
              {item?.serverName && (
                <>
                  <i></i>
                  <div className="tip">{item?.serverName}</div>
                </>
              )}

              {gameMode == 0 && (
                <>
                  <i></i>
                  <div className="tip">
                    {filterTabList?.filter((v) => v?.id === rootId)?.[0]?.name}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="game-detail-info">
            <div className="game-info" onClick={() => goGameList(item)}>
              <div className="game-header-title">
                <div className="title">{item?.title}</div>
                <div className="item-price">
                  ￥{(item?.price * 1 || 0)?.toFixed(2)}
                </div>
              </div>
              <div className="game-tag-list">
                {gameMode == 0 &&
                  (item?.sellPoints || [])?.map((v) => (
                    <span>{v?.tagName}</span>
                  ))}
                {gameMode == 1 && <span>{item?.sub_title}</span>}
              </div>
            </div>

            <div className="item-detail" onClick={() => goGameList(item)}>
              {buttonInfo?.name && (
                <Button
                  shape="default"
                  color="primary"
                  onClick={() => {
                    window.open(`${buttonInfo?.url}`);
                  }}
                >
                  {buttonInfo?.name}
                </Button>
              )}
            </div>
            <div className="game-customer">
              <div className="tag-box">
                <div className="tag-list">
                  <div className="tag-item">找回包赔</div>
                  <div className="tag-item">官方验号</div>
                  <div className="tag-item">安全保障</div>
                </div>
              </div>
              <div className="customer-item" onClick={goCustomer}>
                <div>
                  <UserOutline />
                </div>
                <span>客服</span>
              </div>
              {/* <div className='customer-item'>
                  <div><StarFill /></div>
                  <span>收藏</span>
                </div> */}
            </div>
          </div>
        </div>
      </List.Item>
    );
  };

  const goCustomer = (url) => {
    const URL =
      "https://mobile.yangkeduo.com/mall_page.html?mall_id=372330997&msn=xtlfhtl63xp3wp2ggw22wzrxje_axbuy&_x_outbound_channel=__outbound_mall__";
    const ROUTER = `${url || URL}&Url=${encodeURI(
      window.location.hash.split("#")?.[1]
    )}`;
    const user = navigator.userAgent;
    //android端
    const isAndroid = user.indexOf("Android") > -1 || user.indexOf("Adr") > -1;
    const isiOS = !!user.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      window.location.href = ROUTER;
    } else {
      window.open(ROUTER, "_blank");
    }
  };
  return gameMode == 0 ? gameModeOneItem() : gameModeItem();
};

export default ListItem;
